export default __webpack_public_path__ + "static/media/scroll_top_btn.cf2780ee.png";